import type {
  IPoiTranslation,
  PoiBasicInfoState,
  PoiLocationState,
} from '@/shared/api/types/poi-types'

/*
 * * VI: Snapshot là chuỗi JSON ổn định của từng section; form so snapshot hiện tại với snapshot lúc tải/lưu gần nhất để biết section nào "dirty".
 * * EN: A snapshot is a stable JSON string of one section; the form compares the current one with the snapshot taken at load/last save to tell which section is dirty.
 */

/** Name, description and audio fields are the comparable parts of a translation. */
export function buildPoiTranslationSnapshot(translations: IPoiTranslation[]): string {
  return JSON.stringify(
    translations.map((item) => ({
      language: item.language,
      name: item.name.trim(),
      description: item.description.trim(),
      audioContent: item.audioContent?.trim() ?? '',
      hasAudio: Boolean(item.hasAudio),
      audioUrl: item.audioUrl ?? '',
    })),
  )
}

export function buildPoiLocationSnapshot(location: PoiLocationState): string {
  return JSON.stringify({
    latitude: location.latitude,
    longitude: location.longitude,
    range: location.range,
    address: location.address?.trim() ?? '',
  })
}

/** Includes the destination binding, so changing the destination also marks the section dirty. */
export function buildPoiBasicInfoSnapshot(
  basicInfo: PoiBasicInfoState,
  tenantDestinationId: string,
): string {
  return JSON.stringify({
    category: basicInfo.category,
    type: basicInfo.type,
    popupAd: basicInfo.popupAd,
    range: basicInfo.range,
    tenantDestinationId,
  })
}

/** Compared by uploaded URL; transient `File` objects and blob previews are ignored. */
export function buildPoiMediaSnapshot(urls: string[]): string {
  return JSON.stringify(urls)
}
